// extracted by mini-css-extract-plugin
export default {"formContainer":"checkbox_formContainer__5mIBd"};